import React, { memo } from 'react';
import { XStack, YStack, useTheme } from 'tamagui';
import { GROUP_MEMBERS_CONSTANTS } from '@cobu/types';

interface GroupMembersShimmerProps {
  height?: number;
}

/**
 * GroupMembersShimmer component for displaying loading skeleton
 * 
 * Features:
 * - Shows a horizontal shimmering bar
 * - Configurable height, full width by default
 * - Consistent with design system
 * 
 * @param props GroupMembersShimmerProps
 * @returns JSX.Element
 */
const GroupMembersShimmer: React.FC<GroupMembersShimmerProps> = memo(({
  height = GROUP_MEMBERS_CONSTANTS.SHIMMER.DEFAULT_HEIGHT,
}) => {
  return (
    <YStack
      py="$2"
    >
      <XStack
        f={1}
        h={height}
        bg="$backgroundSecondary"
        br="$4"
        o={GROUP_MEMBERS_CONSTANTS.SHIMMER.OPACITY}
      />
    </YStack>
  );
});

GroupMembersShimmer.displayName = 'GroupMembersShimmer';

export default GroupMembersShimmer; 